export const translations = {
  tr: {
    nav: {
      about: "Hakkımda",
      projects: "Projeler",
      certificates: "Sertifikalar",
      blog: "Blog",
      diagrams: "Diyagramlar",
      contact: "İletişim",
      downloadCV: "CV İndir",
    },
    hero: {
      statement: "Problemlere yazılım çözümleri geliştiriyorum.",
      name: "Mert Özkaya",
      role: "Bilgisayar Mühendisi — Bilkent Üniversitesi",
      cta: {
        projects: "Projelerimi Gör",
        downloadCV: "CV İndir",
      },
    },
    about: {
      label: "Hakkımda",
      title: "Ben Kimim",
      description: "Bilkent Üniversitesi Bilgisayar Mühendisliği son sınıf öğrencisiyim. Yazılım geliştirme, özellikle Unity ile oyun tasarımı ve yapay zekâ uygulamaları üzerine yoğunlaşıyorum. Backend geliştirme, oyun geliştirme ve makine öğrenmesi alanlarında deneyim sahibiyim.",
      skills: ["Java", "Python", "Spring Boot", "Unity", "C#", "Machine Learning", "NLP", "Firebase", "SQL", "Embedded Systems"],
      downloadCV: "CV İndir",
    },
    projects: {
      label: "Projeler",
      title: "Öne Çıkan Projeler",
      subtitle: "Geliştirdiğim projelerden seçmeler.",
      viewDetails: "Detayları Gör",
      watchVideo: "Videoyu İzle",
      viewWebsite: "Siteyi Gör",
      viewCode: "Kodu Gör",
      flagship: "Öne Çıkan Vaka",
      caseStudy: "Vaka İncelemesi",
      modal: {
        problem: "Problem",
        role: "Rolüm",
        approach: "Yaklaşım",
        highlights: "Teknik Öne Çıkanlar",
        results: "Sonuçlar",
        close: "Kapat",
      },
    },
    certificates: {
      label: "Sertifikalar",
      title: "Sertifikalar & Başarılar",
      subtitle: "Sertifikalarımı beceri alanlarına göre düzenlenmiş bir öğrenme haritası olarak sunuyorum.",
      viewCertificate: "Sertifikayı Gör",
      featured: "Öne Çıkan Yetkinlikler",
      library: "Sertifika Kütüphanesi",
      credentialLabel: "sertifika",
      trackTitle: "AI ve mühendislik öğrenme izi",
      trackCopy: "Derin öğrenme, makine öğrenmesi, backend ve mobil geliştirme tarafında tamamlanmış, doğrulanabilir eğitimler.",
      stats: {
        total: "Toplam Sertifika",
        ai: "AI / ML Odağı",
        tracks: "Yetkinlik Alanı",
      },
      categories: {
        ml: "Makine Öğrenmesi",
        deepLearning: "Derin Öğrenme",
        backend: "Backend",
        mobile: "Mobil",
        foundations: "Temeller",
        product: "Ürün & Araçlar",
      },
    },
    blog: {
      label: "Blog",
      title: "Düşünceler",
      subtitle: "Öğrendiklerim ve düşüncelerim üzerine kısa yazılar.",
      readMore: "Devamını Oku",
      close: "Kapat",
    },
    diagrams: {
      label: "Diyagramlar",
      title: "Teknik Diyagramlar",
      subtitle: "Sistem mimarisi ve süreç akışlarını görselleştiren diyagramlar.",
      viewDiagram: "Diyagramı Görüntüle",
      close: "Kapat",
    },
    contact: {
      label: "İletişim",
      title: "Bana Ulaşın",
      subtitle: "Projeler, iş birlikleri veya sadece merhaba demek için aşağıdan ulaşabilirsiniz.",
      email: "E-posta",
      sendEmail: "E-posta Gönder",
    },
    footer: {
      copyright: "© 2025 Mert Özkaya. Tüm hakları saklıdır.",
    },
  },
  en: {
    nav: {
      about: "About",
      projects: "Projects",
      certificates: "Certificates",
      blog: "Blog",
      diagrams: "Diagrams",
      contact: "Contact",
      downloadCV: "Download CV",
    },
    hero: {
      statement: "I build software that matters.",
      name: "Mert Özkaya",
      role: "Software Engineer — Bilkent University",
      cta: {
        projects: "View Projects",
        downloadCV: "Download CV",
      },
    },
    about: {
      label: "About",
      title: "Who Am I ?",
      description: "I'm a senior Computer Engineering student at Bilkent University with a passion for building software that solves real problems. I specialize in backend systems, Unity game development, and machine learning, bringing a blend of engineering rigor and creative problem-solving to every project.",
      skills: ["Java", "Python", "Spring Boot", "Unity", "C#", "Machine Learning", "NLP", "Firebase", "SQL", "Embedded Systems"],
      downloadCV: "Download CV",
    },
    projects: {
      label: "Projects",
      title: "Featured Projects",
      subtitle: "A selection of projects I've built and contributed to.",
      viewDetails: "View Details",
      watchVideo: "Watch Video",
      viewWebsite: "View Website",
      viewCode: "View Code",
      flagship: "Featured Case",
      caseStudy: "Case Study",
      modal: {
        problem: "Problem",
        role: "My Role",
        approach: "Approach",
        highlights: "Technical Highlights",
        results: "Results",
        close: "Close",
      },
    },
    certificates: {
      label: "Certificates",
      title: "Certificates & Achievements",
      subtitle: "A curated learning map organized by capability, not just a list of files.",
      viewCertificate: "View Certificate",
      featured: "Highlighted Credentials",
      library: "Credential Library",
      credentialLabel: "credentials",
      trackTitle: "AI and engineering learning track",
      trackCopy: "Verified training across deep learning, machine learning, backend systems, and mobile development.",
      stats: {
        total: "Total Certificates",
        ai: "AI / ML Focus",
        tracks: "Skill Tracks",
      },
      categories: {
        ml: "Machine Learning",
        deepLearning: "Deep Learning",
        backend: "Backend",
        mobile: "Mobile",
        foundations: "Foundations",
        product: "Product & Tools",
      },
    },
    blog: {
      label: "Blog",
      title: "Thoughts",
      subtitle: "Short writings on things I've learned, and ideas on my mind.",
      readMore: "Read More",
      close: "Close",
    },
    diagrams: {
      label: "Diyagramlar",
      title: "Teknik Diyagramlar",
      subtitle: "Sistem mimarisi ve süreç akışlarını görselleştiren diyagramlar.",
      viewDiagram: "Diyagramı Görüntüle",
      close: "Kapat",
    },
    contact: {
      label: "Contact",
      title: "Get in Touch",
      subtitle: "Have a project in mind, want to collaborate, or just want to say hello? Reach out below.",
      email: "Email",
      sendEmail: "Send Email",
    },
    footer: {
      copyright: "© 2025 Mert Özkaya. All rights reserved.",
    },
  },
};
